import { PatientService } from '@/services/patient.service';
export default {
  props: {
    rowData: {
      type: Object,
      default() {
        return {
          firstname: '',
          lastname: ''
        };
      }
    }
  },
  data() {
    return {
      showDialog: false,
      selectedYear: new Date().getFullYear()
    };
  },
  computed: {
    yearOptions() {
      const currentYear = new Date().getFullYear();
      return this.range(2021, currentYear);
    }
  },
  methods: {
    range(start, end) {
      if (start === end) {
        return [start];
      }
      return [start, ...this.range(start + 1, end)];
    },
    async download(row, selectedYear) {
      try {
        const res = await PatientService.getFSAReceipt(row.id, selectedYear);
        const name = '';
        if (row.firstname) {
          name.concat(row.firstname);
        }
        if (row.firstname && row.lastname) {
          name.concat(' ');
        }
        if (row.lastname) {
          name.concat(row.lastname);
        }
        console.log(res);
        if (res.data) {
          this.getFile(res.data, name);
        }
      } catch (err) {
        // console.log(err.status);
        if (err.status == 404) {
          this.$emit('show-toast', 'There are no order receipts available for this year.');
        } else {
          this.$emit('show-toast', err.message);
        }
      }
    },
    getFile(url, name) {
      const link = document.createElement('a');
      link.href = url;
      const currentDate = new Date();
      if (name) {
        name = ' ' + name;
      }
      link.download = `FSA - ${currentDate}${name}`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};